import * as type from './types';




export function fetchMaruti(values) {
    return {
        type : type.FETCH_MARUTI_SYNC,
        payload: values
    };
}

export function repost(redisId) {
    return {
        type : type.REPOST_REDISID_SYNC,
        payload: redisId
    };
}

export function fetchedMaruti(maruti) {
    return {
        type : type.FETCHED_MARUTI_SYNC,
        payload : maruti
    };
}

export function syncUtd(utd) {
    return {
        type : type.SYNC_UTD_MARUTI,
        payload : utd
    };
}

export function syncedUtd(utd) {
    return {
        type : type.SYNCED_UTD_MARUTI,
        payload : utd
    };
}

export function searchMaruti(maruti) {
    return {
        type : type.SEARCH_MARUTI_SYNC,
        payload : maruti
    };
}


export function storeSearchMarutiResult(maruti) {
    return {
        type : type.STORE_SEARCH_MARUTI_RESULT_SYNC,
        payload : maruti
    };
}

export function filterItems(options) {
    return {
        type : type.FILTER_ITEMS_SYNC,
        payload: options
    };
}

export function pullOldSyncStatus(values) {
    return {
        type : type.PULL_OLD_SYNC_STATUS_MARUTI,
        payload: values
    };
}


export function fetchedPullOldSyncStatus(values) {
    return {
        type : type.FETCHED_PULL_OLD_SYNC_STATUS_MARUTI,
        payload: values
    };
}
export function setNotifyDone(props) {
    return {
        type : type.NOTIFICATION_DONE_ITEM_MARUTI,
        payload: props
    };
}